module.exports = __webpack_public_path__ + "static/media/included9.05c05bd1.svg";